
import reservation_form__rules from "../../../validation/scenarios/reservation_form__rules";

export default {
    model:{
        reservation: reservation_form__rules
    }
};
